import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent, DataBindingDirective } from '@progress/kendo-angular-grid';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { GridSettings, Info } from '../../../core/common';
import { IGetFilterSampleReorderReport, ISampleReorderReport } from '../../../core/models';
import { ProductSampleFulfillmentService } from '../../../core/services/product-sample-fulfillment.service';
import { UserService } from '../../../core/services/user.service';
import { filter } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NotifyType } from '../../../core/enums/NotifyType';
import { AppNotifyService } from '../../../core/services/app-notify.service';
import { CurrencyPipe, formatDate } from '@angular/common';
import { CommonService } from '../../../core/services/common.service';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as Excel from 'exceljs/dist/exceljs.min.js';
import * as ExcelProper from "exceljs";
import * as fs from 'file-saver';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import * as _ from "lodash";

@Component({
  selector: 'app-sample-request-reorder-report',
  templateUrl: './sample-request-reorder-report.component.html',
  styleUrls: ['./sample-request-reorder-report.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SampleRequestReorderReportComponent implements OnInit {
  reorderHeaderGridData: GridDataResult;
  totalReorderGridData: any[] = [];
  reorderGridData: any[] = [];
  reorderLoading: boolean;
  loadingPDF: boolean;
  loadingExcel: boolean;
  isonlyReorder: boolean;
  isInActiveReorder: boolean;
  activeList =
    [
      { name: 'Yes', activeStatus: true },
      { name: 'No', activeStatus: false }];
  //#region label declaration  

  protected reorderReportLblText = {
    stockLbl: 'Stock #',
    categoryLbl: 'Category',
    productDescriptionLbl: 'Product Description',
    costLbl: 'Item Cost',
    stockingLevelLbl: 'Stocking Level',
    currentInventoryLbl: 'Current Inventory',
    reorderPointLbl: 'Reorder Point',
    isReorderLbl: 'Reorder?',
    isActiveLbl: 'Active',
    exportToExcelLbl: 'Export To Excel',
    exportToPDFLbl: 'Export To PDF',
    sampleProductLbl: 'Sample Request Reorder Report',
    onlyReorderItems: 'Display Only Reorders?',
    inactiveReorderItems: 'Include Inactive Items?',
    avgUsagePerMonthLbl: 'Avg Usage/Mo',
    noOfMonthsLbl: 'Months Remaining'
  };
  //#endregion
  constructor(private formBuilder: FormBuilder, private router: Router,
    private userService: UserService, private productSampleFulfillmentService: ProductSampleFulfillmentService,
    private appNotifyService: AppNotifyService, private commonService: CommonService, private cp: CurrencyPipe
  ) { }

  ngOnInit() {
    this.isonlyReorder = false;
    this.isInActiveReorder = false;
    this.getAllReorderReport();    
  }
  public reorderGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'categoryName',
      dir: 'asc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };

  //#region All column settings for the Grid
  public reorderGridSettings: GridSettings = {
    state: this.reorderGridstate,
    gridData: process(this.reorderGridData, this.reorderGridstate),
    columnsConfig: [{
      field: 'stockNum',
      title: this.reorderReportLblText.stockLbl,
      filterable: true,
      widthForPDF: 30,
      _width: 95,
    },
    {
      field: 'categoryName',
      title: this.reorderReportLblText.categoryLbl,
      filterable: true,
      widthForPDF: 60,
      _width: 130,
    }, {
      field: 'subCategoryDescription',
      title: this.reorderReportLblText.productDescriptionLbl,
      //_width: 200,
      filterable: true,
      widthForPDF: 100,
      _width: 250,
    }
      , {
      field: 'currentCostId',
      title: this.reorderReportLblText.costLbl,
      filterable: true,
      widthForPDF: 30,
      _width: 110,
    }
      ,
    {
      field: 'stockingLevel',
      title: this.reorderReportLblText.stockingLevelLbl,
      //_width: 200,
      filterable: true,
      widthForPDF: 30,
      _width: 105,
    }, {
      field: 'currentInventory',
      title: this.reorderReportLblText.currentInventoryLbl,
      //_width: 200,
      filterable: true,
      widthForPDF: 30,
      _width: 95,
    }, {
      field: 'reorderPoint',
      title: this.reorderReportLblText.reorderPointLbl,
      //_width: 200,
      filterable: true,
      widthForPDF: 30,
      _width: 95,
    }, {
      field: 'avgUsagePerMonth',
      title: this.reorderReportLblText.avgUsagePerMonthLbl,
      //_width: 200,
      filterable: true,
      widthForPDF: 30,
      _width: 90,
    }, {
      field: 'noOfMonths',
      title: this.reorderReportLblText.noOfMonthsLbl,
      //_width: 200,
      filterable: true,
      widthForPDF: 30,
      _width: 90,
    }, {
      field: 'isActive',
      title: this.reorderReportLblText.isActiveLbl,
      //_width: 200,
      filterable: true,
      widthForPDF: 30,
      _width: 100,
    }, {
      field: 'isReorder',
      title: this.reorderReportLblText.isReorderLbl,
      //_width: 200,
      filterable: true,
      widthForPDF: 30,
      _width: 90,
    },

    ]
  };
  filterOnlyReorderItems(event) {
    if (event.target.checked) 
      this.isonlyReorder = true;
    else 
      this.isonlyReorder = false;
    this.getFilterReorderItems();
  }
  filterInActiveReorderItems(event) {
    if (event.target.checked) 
      this.isInActiveReorder = true;
    else 
      this.isInActiveReorder = false;
    this.getFilterReorderItems();
  }
  getFilterReorderItems() {
    let totalReorderItems: any[] = [];
    if (this.isonlyReorder && this.isInActiveReorder) {
      let onlyReorderItems: any[] = [];
      for (const [key, value] of Object.entries(this.totalReorderGridData)) {
        if (value.currentInventory < value.reorderPoint)
          onlyReorderItems.push(value);
      }
      this.reorderGridData = onlyReorderItems;
      this.loadReorderHeaderGridData();
    }
    else if (this.isonlyReorder) {
      let onlyReorderItems: any[] = [];
      for (const [key, value] of Object.entries(this.totalReorderGridData)) {
        if (value.currentInventory < value.reorderPoint)
          onlyReorderItems.push(value);
      }
      this.reorderGridData = onlyReorderItems.filter(r => r.isActive == true);
      this.loadReorderHeaderGridData();
    }
    else if (this.isInActiveReorder) {
      this.reorderGridData = this.totalReorderGridData;;
      this.loadReorderHeaderGridData();
    }
    else {
      const dataList = this.totalReorderGridData.filter(r => r.isActive == true);
      this.reorderGridData = dataList;
      this.loadReorderHeaderGridData();
    }      
  }

  getAllReorderReport() {
    this.reorderLoading = true;
    this.productSampleFulfillmentService.getAllReorderReport().subscribe((response: Array<any>) => {
      if (response) {
        this.totalReorderGridData = response;
        this.reorderGridData = response.filter(r => r.isActive == true);
        this.productSampleFulfillmentService.setReorderHeaderGridData(this.reorderGridData);
        this.loadReorderHeaderGridData();
      }
    }, err => {
      this.appNotifyService.notify(NotifyType.ERROR, 'Sorry an error occured while loading the page.');
    })
    this.reorderLoading = false;
  }

  private loadReorderHeaderGridData(): void {
    if (this.reorderGridSettings.state)
      this.reorderHeaderGridData = process(this.reorderGridData, this.reorderGridSettings.state);
    else
      this.reorderHeaderGridData = process(this.reorderGridData, this.reorderGridstate);
    this.reorderGridSettings.gridData = this.reorderHeaderGridData;
  }
  protected reorderHeaderGridSortChange(sort): void {
    this.reorderGridstate.sort = sort;
    this.loadReorderHeaderGridData();
  }

  protected reorderHeaderGridPageChange({ skip, take }: PageChangeEvent): void {
    this.reorderGridstate.skip = skip;
    this.reorderGridstate.take;
    this.loadReorderHeaderGridData();
  }

  public reorderHeaderGridDataStateChange(state: DataStateChangeEvent): void {
    this.reorderGridstate = state;
    this.reorderGridSettings.state = this.reorderGridstate;
    this.loadReorderHeaderGridData();
  }
  generateExcel() {
    this.loadingExcel = true;
    var currFilter = this.reorderGridSettings.state.filter;
    var filterData = process(this.reorderGridData, {
      filter: currFilter
    });
    let workbook: ExcelProper.Workbook = new Excel.Workbook();
    //#region - format data based on column settings
    var titleOutput = [];
    var fieldOutput = [];
    this.reorderGridSettings.columnsConfig.filter(c => c.hidden != true).forEach(c => {
      titleOutput.push(c.title);
      fieldOutput.push(c.field);
    });
    //debugger;
    var dataArray: any[] = [];
    filterData.data.forEach(d => {
      dataArray.push(_.pick(d, fieldOutput));
    });
    //#endregion
    let worksheet = workbook.addWorksheet();
    const header = [this.reorderReportLblText.stockLbl,
      this.reorderReportLblText.categoryLbl,
      this.reorderReportLblText.productDescriptionLbl,
      this.reorderReportLblText.costLbl,
      this.reorderReportLblText.stockingLevelLbl,
      this.reorderReportLblText.currentInventoryLbl,
      this.reorderReportLblText.reorderPointLbl,
      this.reorderReportLblText.avgUsagePerMonthLbl,
      this.reorderReportLblText.noOfMonthsLbl,
      this.reorderReportLblText.isActiveLbl,
      this.reorderReportLblText.isReorderLbl];

    worksheet.addRow([]);
    worksheet.addRow([]);

    let orderDetailsRow = worksheet.addRow([this.reorderReportLblText.sampleProductLbl]);
    orderDetailsRow.font = { size: 10, underline: 'double', bold: true };
    //Add Header row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })

    dataArray.map(p =>
    ([
      p.stockNum ? p.stockNum : '',
      p.categoryName ? p.categoryName : '',
      p.subCategoryDescription ? p.subCategoryDescription : '',
      p.currentCostId ? this.cp.transform(p.currentCostId, 'USD', true, '1.2-2') : '',
      p.stockingLevel ? p.stockingLevel : '',
      p.currentInventory ? p.currentInventory : '',
      p.reorderPoint ? p.reorderPoint : '',
      p.avgUsagePerMonth ? p.avgUsagePerMonth : '',
      p.noOfMonths ? p.noOfMonths : '',
      p.isActive ? (p.isActive == true ? 'Yes ' : 'No') : 'No',
      p.isReorder ? p.isReorder : '',
    ])
    )
      .forEach(d => {
        let row = worksheet.addRow(d);
      });
    worksheet.addRow([]);
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'SampleRequestReorderReport.xlsx');
    })
    this.loadingExcel = false;
  }

  async generatePDF() {
    //debugger;
    this.loadingPDF = true;
    var currFilter = this.reorderGridSettings.state.filter;
    var filterData = process(this.reorderGridData, {
      filter: currFilter
    });
    //#region - format data based on column settings
    var titleOutput = [];
    var fieldOutput = [];
    var widthOutput = [];
    this.reorderGridSettings.columnsConfig.filter(c => c.hidden != true && c.widthForPDF > 0).forEach(c => {
      titleOutput.push(c.title);
      fieldOutput.push(c.field);
      widthOutput.push(c.widthForPDF);
    });
    //debugger;
    var dataArray: any[] = [];
    filterData.data.forEach(d => {
      dataArray.push(_.pick(d, fieldOutput));
    });
    //#endregion
    var todaysDate = formatDate(new Date(), 'MM/dd/yyyy', 'en');
    let docDefinition = {
      header: {
        columns: [
          { text: todaysDate, margin: [10, 12, 10, 20] },
          { text: this.reorderReportLblText.sampleProductLbl, alignment: 'center', margin: [10, 12, 0, 20] }
        ]
      },
      content: [
        {
          // under NodeJS (or in case you use virtual file system provided by pdfmake)
          // you can also pass file names here
          image: await this.commonService.getBase64ImageFromURL(
            location.origin.toString() + "/assets/images/kawneer_logo.JPG"
          ),
          alignment: 'center', fit: [150, 150]
        },
        {
          text: "Sample Request Reorder List",
          style: 'sectionHeader'
        },
        {
          style: 'tableStyle',
          table: {
            headerRows: 1,
            //widths: ['*'],
            widths: widthOutput,            
            body: [
              [
                this.reorderReportLblText.stockLbl,
                this.reorderReportLblText.categoryLbl,
                this.reorderReportLblText.productDescriptionLbl,
                this.reorderReportLblText.costLbl,
                this.reorderReportLblText.stockingLevelLbl,
                this.reorderReportLblText.currentInventoryLbl,
                this.reorderReportLblText.reorderPointLbl,
                this.reorderReportLblText.avgUsagePerMonthLbl,
                this.reorderReportLblText.noOfMonthsLbl,
                this.reorderReportLblText.isActiveLbl,
                this.reorderReportLblText.isReorderLbl,
              ],
              ...filterData.data.map(p =>
              ([
                p.stockNum ? p.stockNum : '',
                p.categoryName ? p.categoryName : '',
                p.subCategoryDescription ? p.subCategoryDescription : '',
                p.currentCostId ? this.cp.transform(p.currentCostId, 'USD', true, '1.2-2') : '',
                p.stockingLevel ? p.stockingLevel : '',
                p.currentInventory ? p.currentInventory : '',
                p.reorderPoint ? p.reorderPoint : '',
                p.avgUsagePerMonth ? p.avgUsagePerMonth : '',
                p.noOfMonths ? p.noOfMonths : '',
                p.isActive ? (p.isActive ==true ? 'Yes ' : 'No') : 'No',
                p.isReorder ? p.isReorder : '',
                
              ])
              )
            ]
          }
        }
      ],
      footer: {
        columns: [
          { text: '©1991-2021 Arconic. All rights reserved.', alignment: 'center' }
        ]
      },
      styles: {
        headerLeft: {
          fontSize: 22,
        },
        headerRight: {
          fontSize: 22,
          alignment: 'center'
        },
        anotherStyle: {
          italics: true,
          alignment: 'right'
        },
        sectionHeader: {
          bold: true,
          decoration: 'underline',
          fontSize: 14,
          margin: [0, 15, 0, 15]
        },
        tableStyle: {
          fontSize: 8
        }
      }
    };

    pdfMake.createPdf(docDefinition).download('SampleRequestReorderReport.pdf');
    this.loadingPDF = false;
  }
}
